export default {
      id: "Icon--directions-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--directions",
      toString: function () {
        return this.url;
      }
    }